// the vehicle classes the application can work with
export const validVehicleClasses = ['Car', 'Motorbike']
